import axios from 'axios'

let resolveFetchResult = null
const fetchResultPromise = new Promise(function (resolve, reject) {
  resolveFetchResult = resolve;
});

const store = {
  namespaced: true,
  state: {
    hamburgerMenuActive: true,
    results: {},
    showSearch: false,
    stamDataLanden: {},
    stamDataGeslacht: {},
    portalLogo: '/mediq_logo.svg',
    backgroundLogo: null,
    userMarketingPermission: false,
    registrationDetails: {},
    alertMessageDetails: {},
    warehouses: null,
    siteCode: '',
    demo: false,
    demoActivated: false,
    demoFlow: {
      navigation: false,
      search: false,
      patientFollow: false,
      createLicense: false,
      myPatients: false,
      showLicense: false,
      createLicenseTwoColumn: false,
      catalogFlow: false,
      patientListing: false,
      checkoutFlow: false
    }
  },
  mutations: {
    setHamburgerMenuActive (state, payload) {
      state.hamburgerMenuActive = payload
    },
    setStamDataLanden (state, payload) {
      state.stamDataLanden = payload
    },
    setStamDataGeslacht (state, payload) {
      state.stamDataGeslacht = payload
    },
    setBackgroundLogo (state, payload) {
      state.backgroundLogo = payload.bgImage
    },
    setUserMarketingPermission (state, payload) {
      state.userMarketingPermission = payload
    },
    setRegistrationDetails (state, payload) {
      state.registrationDetails = payload.registration
    },
    setAlertMessageDetails (state, payload) {
      state.alertMessageDetails =  {
        loginHighPrioMessage: payload.loginHighPrioMessage,
        internetExplorerAlertMessage: payload.internetExplorerAlertMessage
      }
    },
    setWarehouses (state, payload) {
      state.warehouses = payload
    },
    setUserSiteCode (state, payload) {
      state.siteCode = payload
    },
    setDemoStatus (state, payload) {
      state.demo = payload
    },
    setDemoActivation (state, payload) {
      state.demoActivated = payload
    },
    setDemoFlowStatus (state, payload) {
      state.demoFlow[payload.key] = payload.value
    }
  },
  actions: {
    updateResults ({ commit }, response) {
      resolveFetchResult(response);
      commit('setUserMarketingPermission', response.usermarketingpermission)
      commit('setWarehouses', response.warehouses)
      commit('setUserSiteCode', response.siteCode)
      commit('setDemoStatus', response.showDemo)
    },
    fetchResults ({ commit }) {
      return fetchResultPromise;
    },
    fetchStamDataLanden ({ commit }) {
      return axios.get('StamData/GetLanden')
        .then((response) => {
          commit('setStamDataLanden', response.data)
        })
    },
    // Not used yet (maybe remove it from the /F34a/Init when necessary)
    fetchStamDataGeslacht ({ commit }) {
      return axios.get('StamData/GetGeslachten')
        .then((response) => {
          commit('setStamDataGeslacht', response.data)
        })
    },
    fetchPortalLogo ({ commit }) {
      return axios.get('nav/GetPortalDetails').then((response) => {
        commit('setBackgroundLogo', response.data)
        commit('setRegistrationDetails', response.data)
        commit('setAlertMessageDetails', response.data)
      })
    },
    // Update demo status
    updateDemoStatus ({ dispatch }, demoStatus) {
      axios.post('User/UpdateDemoStatus?showDemo=' + demoStatus).then((response) => {
        dispatch('fetchResults')
      })
    }
  },
  getters: {
    gethamburgerMenuActive: state => {
      return state.hamburgerMenuActive
    },
    getStamDataLanden: state => {
      return state.stamDataLanden
    },
    getStamDataGeslacht: state => {
      return state.stamDataGeslacht
    },
    getPortalLogo: state => {
      return state.portalLogo
    },
    getBackgroundLogo: state => {
      return state.backgroundLogo
    },
    getUserMarketingPermission: state => {
      return state.userMarketingPermission
    },
    getRegistrationDetails: state => {
      return state.registrationDetails
    },
    getAlertMessageDetails: state => {
      return state.alertMessageDetails
    },
    getWarehouses: state => {
      return state.warehouses
    },
    getSiteCode: state => {
      return state.siteCode
    },
    getDemoStatus: state => {
      return state.demo
    },
    getDemoActivatedStatus: state => {
      return state.demoActivated
    },
    getDemoFlowStatus: state => {
      return state.demoFlow
    }
  }
}

export default store;
